import React, {useEffect, useState} from 'react';
import {Box} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import InternalTemplate from '../../../../../components/templates/internal';
import {IReceivable} from '../../../../../interfaces/dtos';
import {StackParamList} from '../../../../../navigators';
import {SpinnerModal} from '../../../../../components/modals';
import {EmptyListIcon} from '../../../../../components/icons';
import ReceivableItem from './item/item';
import {useSalesmanContext} from '../../../../../context/salesman';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'SalesmanReceivables'
>;

const ReceivableListScreen = ({navigation, route}: ScreenProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const {balances, receivables, fetchReceivableListByDebtor} =
    useSalesmanContext();
  const {debtor, key} = route.params;

  const getReceivableList = async () => {
    setIsLoading(true);
    await fetchReceivableListByDebtor(key, debtor.rif);
    setIsLoading(false);
  };

  useEffect(() => {
    if (debtor) {
      getReceivableList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGoBack = () => {
    navigation.goBack();
  };

  function isOdd(num: number) {
    return num % 2;
  }

  const Content = () => {
    if (isLoading) {
      return <></>;
    }
    if (balances?.length === 0) {
      return <EmptyListIcon />;
    }
    if (receivables) {
      return (
        <>
          {receivables.map((deb: IReceivable, index: number) => (
            <ReceivableItem
              key={`balance-item-${index}`}
              {...deb}
              onPress={() => {}}
              rowType={isOdd(index) ? 'odd' : 'even'}
            />
          ))}
        </>
      );
    }

    return <></>;
  };

  return (
    <InternalTemplate
      title={debtor.client}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'back-debtors',
        usage: 'external',
      }}>
      <SpinnerModal show={isLoading} />
      <Box marginBottom={20} marginTop={3}>
        <Content />
      </Box>
    </InternalTemplate>
  );
};
export default ReceivableListScreen;
